<template>
  <Modal class="align-l" v-model="show" :mask-closable="false"  @on-ok="save" :loading="loading">
    <div slot="header" class="modal-header">删除物品档案</div>
    <p class="mb16">{{ '是否确认删除物品【' + goodsName + '】'}}</p>
    <Form :model="formData" :label-width="60"  :rules="formRules" ref="deleteGoods">
      <FormItem label="备注" prop="remark">
        <Input v-model="formData.remark" type="textarea" :rows="6" class="area-width"></Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script type="text/ecmascript-6">
import {deleteGoods} from 'api/archives'

export default {
  props: {
    n: {
      type: Number,
      default: 0
    },
    goodsName:{
      type: String,
      default:''
    },
    goodsArchivesCode:{
      type: String,
      default:''
    }
  },
  created(){
  },
  data() {
    return {
      show: false,
      loading: true,
      data:{
        goodsArchivesCode:'',
        remark:''
      },
      formData:{
        remark:'',
      },
      formRules:{
        remark:[
          { required: true, message: '请输入备注' ,trigger:'blur',type:'string'}
        ]
      }
    };
  },
  watch: {
    n(val) {
      this.show = true;
      this.$refs['deleteGoods'].resetFields();
    }
  },
  methods: {
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    save() {
      this.$refs["deleteGoods"].validate(bool => {
        if (bool) {
          this.data.remark = this.formData.remark;
          this.data.goodsArchivesCode = this.goodsArchivesCode
          deleteGoods(this.data).then( res => {
            this.$Message.success('删除成功');
            this.changeLoading()
            this.show=false
            this.$emit('refresh')
          }).catch( () => {
            this.changeLoading()
          })
        } else {
          this.changeLoading();
          return;
        }
      });
    }
  }
};
</script>
 
<style lang="css">

.area-width{
    width: 324px;
}
.align-l .ivu-form  .ivu-form-item-label{
  text-align: left;
}
</style>